import(/* webpackMode: "eager" */ "/workspace/app/[locale]/page.tsx");
